// @flow

import _isArray from 'lodash/isArray';
import * as yup from 'yup';

yup.addMethod(yup.number, 'germanNumber', function transform() {
  return this.transform((value, originalValue) => {
    const valid = /(?=.)^\$?(([1-9][0-9]{0,2}(\.[0-9]{3})*)|[0-9]+)?(,[0-9]{1,})?$/.test(
      originalValue
    );

    return valid
      ? parseFloat(
          originalValue
            .replace(/\./g, '')
            .replace(',', '.')
            .trim()
        )
      : null;
  });
});

export default validationConfigs => {
  const { rules, schemaType } = validationConfigs;

  if (!yup[schemaType]) {
    throw new Error(`Invalid schema validation type: ${schemaType}`);
  }

  if (!_isArray(rules) || !rules.length) {
    throw new Error('Atleast one rule should be defined');
  }

  let validator = yup[schemaType]();

  rules.forEach(rule => {
    const { params = [], type } = rule;

    if (!validator[type]) {
      return;
    }

    validator = validator[type](...params);
  });

  return validator;
};
